/* eslint-disable no-useless-return */
/* eslint-disable no-debugger */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";
import Select, { components } from "react-select";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@material-ui/core";
import axios from "axios";
import { useHistory } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { MdReplay } from "react-icons/md";
import styles from "./BookingDetailsOperative.module.css";
import {
  CustomDatePicker,
  CustomFormGroup,
} from "../../components/FormComponents";
import {
  MESSAGE_TYPE,
  RESOURCE_TYPE,
} from "../../constants";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { Button, CustomTab } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import BackButton from "../../components/BackButton/BackButton";
import {
  fetchChassis,
  getInvoice,
} from "../../redux/actions/productsActions";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import MultiSelect from "../../components/FormComponents/MultiSelect";
import { setLogin } from '../../redux/features/auth/actions';
import { canDeleteBooking, sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";


const initialState = {
  plant: null,
  part: null,
  aqCommodity: null,
  purchaseCommodity: null,
  supplierCode: null,
  supplierDetails: null,
  supplierName: "",
  supplierLocation: "",
  selectedProject: null,
  selectedPO: null,
  inputFields: {
    purchaseBuyerName: "",
    suppRepresentativeName: "",
    suppRepresentativeContact: "",
    suppRepresentativeEmail: "",
  },
  errors: {},
  searchBox: "",
};
const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "reset":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

const BookingDetailsOperative = () => {
  const ROW_HEIGHT = 38;
  const history = useHistory();

  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };
 
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showInternalError } = usePopupManager();
  const { showPopup } = usePopupManager();
  const dispatchNew= useDispatch();

  let {
    userName,
    personNumber,
    companyCode,
    bookingStatus,
    costCenter,
    userRole,
    sessionId,
    persArea,
  } = auth;

  

  const {
    aqCommodity,
    purchaseCommodity,
    selectedProject,
    selectedPO,
    inputFields,
    errors,
  } = state;

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const [totalData, setTotalData] = useState([]);
  const [barrelData, setBarrelData]= useState(false);
  const [projectData, setProjectData]= useState(false);
  const[totalProject,setTotalProject]=useState([])
  const [tableData, setTableData] = useState([]);
  const [OperativeDropdownList, setOperativeDropdownList] = useState([]);
  const [opTicketNo, setOpTicketNo] = useState();
  const [oprativeDetails, setOprativeDetails] = useState([]);
  const [oprativeName, setOprativeName] = useState([]);
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
 const [barrelDropdown, setBarrelDropdown] = useState([]);
  const [Pro_NoDropdown, setpro_NoDropdown] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [deleteRow,setDeleteRow] =useState([]);

  const [myState, setState] = React.useState({
    barrel_code:[],
    project_def:[],
    searchBox:"",
  });


  const [selectedProjectsDetails, setSelectedProjectsDetails] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [modifiedData, setModifiedData] = useState([]);
  const [dataDB, setDataDB] = useState([]);
  const handleCheckboxChange = (event, index) => {
    const { checked } = event.target;
    setCheckedItems((prevState) => ({
      ...prevState,
      [index]: checked,
    }));
  
    // If the checkbox is checked, find other checkboxes with the same date and select them
    if (checked) {
      const selectedDate = selectedProjectsDetails[index]?.date;
      
      // Find the indices of other items with the same date
      const indicesWithSameDate = selectedProjectsDetails.reduce(
        (accumulator, item, i) => {
          if (item.date === selectedDate) {
            accumulator.push(i);
          }
          return accumulator;
        },
        []
      );
  
      // Update the state to select checkboxes with the same date
      setCheckedItems((prevState) => {
        const updatedState = { ...prevState };
        indicesWithSameDate.forEach((i) => {
          updatedState[i] = true;
        });
        return updatedState;
      });
    } else {
      // If the checkbox is unchecked, deselect other checkboxes with the same date
      const selectedDate = selectedProjectsDetails[index]?.date;
      const indicesWithSameDate = selectedProjectsDetails.reduce(
        (accumulator, item, i) => {
          if (item.date === selectedDate) {
            accumulator.push(i);
          }
          return accumulator;
        },
        []
      );
  
      // Update the state to deselect checkboxes with the same date
      setCheckedItems((prevState) => {
        const updatedState = { ...prevState };
        indicesWithSameDate.forEach((i) => {
          updatedState[i] = false;
        });
        return updatedState;
      });
    }
  };

  const updateFinalData = () => {
    const filteredData = modifiedData.filter(
      (item, index) => checkedItems[index] === true
    );
    setFinalData(filteredData);
  };

  useEffect(() => {
    if (finalData.length !== 0) {
      const resultList =  finalData.map((projectData) => (
        {
          "co_code":sanitizeCoCodeNumeric(companyCode),
           "pers_no":sanitizeNumeric(opTicketNo[0]),
          "booking_date":projectData.date,
          "approval_status":projectData.approval_status
        }
        ))
        setDataDB(resultList);
    }
  }, [finalData]);
  const handleSelectedProjectsChange = (newSelectedProjects) => {
  
    const newModifiedData = newSelectedProjects.map((item) => ({
      ...item,
      remark: item.remark || "",
    }));
    setModifiedData(newModifiedData);
  };


  useEffect(() => {
    if (selectedProjectsDetails?.length > 0) {
      handleSelectedProjectsChange(selectedProjectsDetails);
    }
  }, [selectedProjectsDetails]);


  useEffect(() => {
    if (checkedItems.length != 0) {
      updateFinalData();
    }
  }, [checkedItems, modifiedData]);

  

  const convert2 = (str) => {
    if (str == null) {
      return "";
    } else {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
       return [date.getFullYear(), mnth, day].join("-"); //  2022-03-29
    }
  };

  const getOperativeDetails = () => {
    let apiFormatedData = {
      supno: sanitizeNumeric(personNumber),
    };
    
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}timeBooking/GetOperativeDetails`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson) {
          const OperativeList=[]
          responseJson.result.map((row)=>{
            OperativeList.push({label:`${row.emp_tkt_no}-${row.complete_name}`,
            value: row.emp_tkt_no          
          });
        })
        const OperativeTicket=[]
        responseJson.result.map((row)=>{
          OperativeTicket.push(row.emp_tkt_no)
        })
          setOperativeDropdownList(OperativeList)
          setOpTicketNo(OperativeTicket)
        }
        
      })
      .catch((error) => {
        console.log(error)
       
      });
      
  };

  useEffect(() => {
    getOperativeDetails();
    
  }, []);

  const BookingOperativeDetails = () => {
   
    let apiFormatedData = {
      pers_no: sanitizeNumeric(oprativeDetails.value),
      co_code: sanitizeCoCodeNumeric(companyCode)
    };
    
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}timeBooking/BookingOperativeDetails`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson) {
          const barrelList=[]
          responseJson.result.Barrel_data.map((row)=>{
            barrelList.push({label:row.code_desc,value:row.code_code})
          })
          let jsonObjects = barrelList?.map(JSON.stringify);
          let uniqueSets = new Set(jsonObjects);
          let uniqueArray = Array.from(uniqueSets)?.map(JSON.parse); 
          setBarrelDropdown(uniqueArray)
          setTotalData(responseJson.result.Barrel_data)
        
          const Project_Nodropdown = []
          responseJson.result.project_data.map((row)=>{
            Project_Nodropdown.push({ label: row.project, value: row.peoject_def});                  
        })
        setTotalProject(Project_Nodropdown)
          setpro_NoDropdown(Project_Nodropdown);
          
        }
        else {
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Blank message",
          });
        }

      })
      .catch((error) => {    
      });
      
  };

  
  
  useEffect(() => {
    if(oprativeDetails.length!=0){
    BookingOperativeDetails();
    }
  }, [oprativeDetails]);

  const handleSearch = ()=>{
    setState((prevState) => ({ ...prevState, checkTable: true }));  
    let apiFormatedData = {
        co_code: sanitizeCoCodeNumeric(companyCode),
        pers_no: sanitizeNumeric(oprativeDetails?.value),
        start_date:toDate,
        end_date:fromDate,
        barrel_code:myState.barrel_code ? myState.barrel_code.map((item) => item.value).join(",") : "",
        project_def: myState.project_def ? myState.project_def.map((item) => item.value).join(",") : "",
    };  
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}timeBooking/SearchOperativeDetails`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson) {
          
          if(responseJson.result == undefined || responseJson.result == 0) {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Data not found",
            })
          }

          setSelectedProjectsDetails(responseJson.result)       
        }
        else{
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Empty Table Data",
          })
        }

      })
      .catch((error) => {
        console.log(error)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Empty Table Data",
        });
      });
}
 
  const handleDelete = () => {
    if (finalData.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select at least one project.",
      });
      return; // Stop further processing
    }
    else{   
      const hasInvalidDeletion = finalData.some(
              (row) => !canDeleteBooking(row)
            );
            const deletableProjects = finalData.filter((projectData) =>
              canDeleteBooking(projectData)
            );
            if (hasInvalidDeletion) {
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Deletion not allowed based on approval or booking date rules.",
              });
              return;
            }
      else{    
      const resultList = deletableProjects.map((projectData) => ({
      co_code: sanitizeCoCodeNumeric(companyCode),
      pers_no: sanitizeNumeric(oprativeDetails?.value),
      booking_date: projectData.date,
      approval_status: projectData.approval_status_code,
      }));
      axios
      .post(`${baseUrl}timeBooking/DeleteOperativeDetails`, resultList,{
        headers: {
        'Content-Type': 'application/json',
        },
        withCredentials:true,
      })
      .then((res) => {
        dispatchNew(setLogin({...auth, recentStatus: res.status}))
        if (res.data.msg === "Booking Deleted Successfully...") {    
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: res.data.msg,
            reloads: true, // Set reload to true or false based on your condition
          });
        }
        else{
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: res.data.msg,
            reloads: true,
          });
        }
      })
      .catch((error) => {
        dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        console.error("Error while deleting projects:", error);
      });
    }}
  };  

  const handleSelect = (selectedOption) => {
    
    
    setOprativeDetails(selectedOption);
     const selectedObject = OperativeDropdownList.find((item) => item.value === selectedOption.value);
    
    const relatedNameValue = selectedObject.value ? selectedObject.value : 'Unknown';
    setOprativeName(relatedNameValue);
    
    }

    const handleDropdown = (data , name) => {
             setBarrelData(true)
             if(name == 'project_def'){
              setProjectData(true)
             }
              if(data == null){
          setState((prevData) => ({ ...prevData, [name]: null }))
        }
        else{
      setState((prevData) => ({ ...prevData, [name]: data }))
        }
      
        if(name=="barrel_code"){
          if(data){
            let newData=data?.map((data1)=>data1.value)
            let filterData=totalData?.filter((datas)=>newData?.includes(datas.code_code))
            let keyValue=filterData?.map(({project_def,project})=>({
             label:project,
             value:project_def
            }))           
            let jsonObject = keyValue?.map(JSON.stringify);
            let uniqueSet = new Set(jsonObject);
            let uniqueArray = Array.from(uniqueSet)?.map(JSON.parse); 
           setpro_NoDropdown(uniqueArray) 
          }
            else{
              setpro_NoDropdown(totalProject) 
            }        
        }
     

    }

    const handleCancelClick = () => {
      window.location.reload();
    };

  
  const strflag = () => {
    var regexp = new RegExp(/^[a-zA-Z0-9 ]+$/);
    let str = myState.chassisNo;
    if (myState.chassisNo == "") {
      return;
    }

    if (regexp.test(str)) {
      setState((prevData) => ({ ...prevData, chassisNoFlagStr: false }));
      return true;
    } else {
      setState((prevData) => ({ ...prevData, chassisNoFlagStr: true }));
      return false;
    }
  };

  const BG_COLOR = "#fffef8";
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false,
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } =
    backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
    });

  const handleClose = () => setIsPopupOpen(false);
 
  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if (myState.checkFlag == true) {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
      }));
    }

    setTableData([]);
    setHighlightMandatoryFields(false);
  };

  const renderOther = () => (
    <div
      className={styles.formGroup}    
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}      
        columns={12}
      >
        <Grid  item md={2} lg={2} sm={4} xs={4} style={{marginTop:"5px"}}>
        <div className={styles.rowDiv}>
                <div className={clsx(styles.lableDiv2)}>
              <label>Operative Details:</label>
            </div>
          </div>
        </Grid>
        <Grid  item md={3} lg={3} sm={7} xs={7}>
           <div className={styles.rowDiv}>
             <Select
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isClearable
                value={oprativeDetails}
                options={OperativeDropdownList}
                onChange={handleSelect}
               
             />
            </div>
       
        </Grid>
        </Grid>  
        <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        columns={12}
      >

        {oprativeDetails.length!=0 &&
        <>
        <Grid item md={2} lg={2} sm={3} xs={3}>
        <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            </div>
        </Grid>
        <Grid item md={3} lg={3} sm={9} xs={3}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                value={toDate}
                onChange={(date) => setToDate(date)}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                maxDate={moment().toDate()}
              />
              
            </div>
          </div>
          {myState.handoverDateFlag && (
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
        
        <Grid  item md={2} lg={2} sm={3} xs={3}>
        <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            </div>
        </Grid>
        <Grid item md={3} lg={3} sm={9} xs={3}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <CustomDatePicker
                // isMandatory

                clearable
                autoOk
                inputVariant="outlined"
                value={fromDate}
                onChange={(date) => setFromDate(date)}

                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
        
          <Grid
          container
          spacing={1}
          style={{ marginTop: "10px" }}
          // className={styles.myGrid}
          columns={12}
        >

        <Grid item md={2} lg={2} sm={3} xs={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Barrel</label>
            </div>
            </div>
        </Grid>
        <Grid item md={3} lg={3} sm={9} xs={9}>
          <div className={styles.rowDiv}>
             <MultiSelect
                widths="500px"
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isMulti={true}
                isClearable
                options={barrelDropdown}
                onChange={(e)=>{  
                handleDropdown(e,'barrel_code')}}
                value={myState.barrel_code}
                
             />
            </div>
        </Grid>
        <Grid item md={2} lg={2} sm={3} xs={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Project No.</label>
            </div>
            </div>
        </Grid>
        <Grid item md={3} lg={3} sm={9} xs={9}>
          <div className={styles.rowDiv}>
             <MultiSelect
                isMandatory
                widths="450px"
                className={clsx(styles.select, styles.sel2)}
                isMulti={true}
                isClearable           
                value={myState.project_def}
                options={Pro_NoDropdown}
                onChange={(e)=>{handleDropdown(e,'project_def')}}
                
             />
            </div>
        </Grid>
        <Grid item md={2} lg={2} sm={12} xs={12}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                onClick={() => runPreSubmissionChecks() && handleSearch()}
                
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
              >
                Search
              </Button>
            </div>
          </div>
        </Grid>
        </Grid>
        </>
        }
      </Grid>
    </div>
  );

  

  const renderReport = () => (
    <div className={styles.formGroup}>    
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        
        <Grid item md={12} lg={12} xs={12} sm={12}>
        <TableSimple
              tableColumnData={selectedProjectsDetails?.map((item, index) => ({
                select: (
                  <input
                    type="checkbox"
                    checked={checkedItems[index] || false}
                    disabled={!canDeleteBooking(item)}
                    onChange={(event) => handleCheckboxChange(event, index)}
                  />
                ),
                Date :moment(item.date).format("DD-MM-YYYY"),
                ProjectNo:item.project_def == null ? ""  : item.project_def,
                ProjectDesc:item.project_desc == null ? ""  : item.project_desc,
                Gate : item.activity_desc,
                Module : item.mfl,
                Status : item.approval_status,
                Hrs :item.hrs,
              }))}
              tableHeaderLabel={[
                "Select_27",
                "Date_48",
                // "Project Details",
                "Project/Indirect No_60",
                "Project/Indirect Desc_150",
                "Gate (EVM Activity)_150",
                "Module(MFL)_150",
                "Status_45",
                "Hrs_20"
              ]}
              TableRowHederAling="center"
              size="small"
              headerColor="#E6F2FF"
              className="custom-table"
            />       
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px", justifyContent: "center" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              
              <Button
                 className={clsx(styles.actionButton)}
                 variant="primary"
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
                onClick={handleDelete}
                

              >
                Delete 
              </Button>
              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="tertiary"
                style={{ marginRight: "5px" }}
                onClick={handleCancelClick}
              >
                Cancel
              </Button>
              
            </div>
          </div>
        </Grid>
        </Grid>
    </div>
  );

  const getSelectedFields = () => ({
    projectId: selectedProject,
    poNumber: selectedPO,
    commodityGroupId: purchaseCommodity && purchaseCommodity.value,
    aqCommodityGroupId: aqCommodity && aqCommodity.value,
    purchaseBuyerName: inputFields?.purchaseBuyerName,
    kamContactDetails: {    
      name: inputFields?.suppRepresentativeName,
      contactNumber: inputFields?.suppRepresentativeContact,
      emailId: inputFields?.suppRepresentativeEmail,
    },
  });

  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails };
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };

  const runPreSubmissionChecks = () => {
    const selectedFields = getSelectedFields();
    const areFieldsValid = validateFields(selectedFields);

    if (!areFieldsValid) {
      setHighlightMandatoryFields(true);
      // return false;
      return true;
    }
    return true;
  };

  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: "",
    };
    dispatch({ type: "update", field: "inputFields", value: inputs });
    dispatch({ type: "update", field: "errors", value: {} });
  };

  const resetState = () => {
    dispatch({ type: "reset" });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor("processInfoBg");
  };

  useEffect(() => {
    if (resetAllVisitedFields) resetState();
  }, [resetAllVisitedFields]);

  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
            <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="Home"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Time Booking" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel
            />
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          <CustomFormGroup
            header="Booking Details Operatives"
            body={renderOther()}
          />
          {myState.checkTable && selectedProjectsDetails.lenght !==0 && 
          renderReport()
          }  
           
        </div>
      </div>  
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />
    </>
  );
}

function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to reset the filters?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

BookingDetailsOperative.propTypes = {
  redirectToProcessPage: PropTypes.func,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired,
};

ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
BookingDetailsOperative.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingDetailsOperative);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);